import { TFiltersState } from "./filtersSlice";

export const getFilteredByKey = (filters: TFiltersState['filters']) => Object.fromEntries(
  Object.entries(filters).filter(([key, value]) => value !== undefined && value !== null && value !== ''));